var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.8 14.8",
    style: {
      enableBackground: "new 0 0 14.8 14.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,14.3H2.9c-1.3,0-2.3-1-2.3-2.3V2.7c0-1.3,1-2.3,2.3-2.3H6c0.4,0,0.8,0.3,0.8,0.8S6.4,2,6,2H2.9 C2.5,2,2.1,2.3,2.1,2.7V12c0,0.4,0.3,0.8,0.8,0.8h9.2c0.4,0,0.8-0.3,0.8-0.8V8.9c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8V12 C14.4,13.3,13.4,14.3,12.1,14.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,1.2v3.8c0,0.3-0.2,0.6-0.5,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.1-0.5-0.2l-1.4-1.4L8,8 C7.7,8.3,7.2,8.3,6.9,8c0,0,0,0,0,0c-0.3-0.3-0.3-0.8,0-1.1c0,0,0,0,0,0l3.7-3.7L9.2,1.8C9,1.6,8.9,1.2,9,0.9 c0.1-0.3,0.4-0.5,0.8-0.5h3.8c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.2,0.1,0.3,0.2,0.4,0.4c0,0,0,0.1,0,0.1 C14.4,1.1,14.4,1.1,14.4,1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.86a83dd69a6aeef3b2e740886e7e0ffa.svg";
export { ForwardRef as ReactComponent };